import React from 'react';
import Main from '../components/Aboutus/Aboutus';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

function Aboutus() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Aboutus;
